export function deleteField<T, K extends keyof T>(object: T, key: K): Omit<T, K> {
    const { [key]: field, ...rest } = object
    return rest
}

/*
export function deleteField<T, C = T, Pa extends string = ''>(getPath: (selector: PathSelector<T, T>) => PathSelector<T, C, Pa>, object: T): Omit<T, Pa> {
    const withoutField = { ...object }

    getPath(pathSelector<T, T>()).getPath().split('.').reduce((acc: any, key: string, index, list) => {
        if (index === (list.length - 1)) {
            delete acc[key]
        }
        return acc[key]
    }, {})

    return withoutField
}
*/